import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ProviderModel} from './ProviderModel';

export class DiscountModel {
  id: number;
  numAnno: number;
  discount: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  provider: ProviderModel;
  numAnnoFrom: number;
  numAnnoTo: number;
}
